// The "nothing chosen yet" state for Compliance/Konfiguration's detail panel — Arbejdskø's own empty
// state is a plain sentence; this one gets our own mark on it instead of sitting there blank.
import React from 'react';
import Logo from './Logo';
import './DetailEmpty.css';

export default function DetailEmpty({ text }) {
  return (
    <div className="detail-empty">
      <Logo size={40} />
      <p>{text}</p>
    </div>
  );
}
